<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span class="bind">角色权限管理</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-tree
                :data="rulesTree"
                show-checkbox
                default-expand-all
                node-key="id"
                ref="tree"
                highlight-current
                check-strictly
                :default-checked-keys="defaultCheck"
                :props="defaultProps"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="6"
              class="rules-col">
              <el-button-group class="rules-button-group">
                <el-button
                  type="primary"
                  @click="saveChecked">保存</el-button>
                <el-button @click="resetChecked">清空</el-button>
              </el-button-group>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      rulesTree: [],
      defaultCheck: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
  mounted() {
    this.$http._get({
      url: '/index/Power/groupRules',
      data: { id: this.$route.params.id }
    }).then((res) => {
      if (res.result === 0) {
        this.rulesTree = res.data.rulesTree;
        this.defaultCheck = res.data.defaultCheck;
      }
    }).catch(() => {
      this.$router.go(-1);
    });
  },
  methods: {
    saveChecked() {
      this.$confirm('是否确认保存改角色访问权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/Power/groupRules',
          data: { roleid: this.$route.params.id, rules: this.$refs.tree.getCheckedKeys() },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
            this.$router.go(-1);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
      console.log(this.$refs.tree.getCheckedKeys());
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    }
  },
  watch: {

  },
};
</script>
<style>
  .rules-col {
    display: block;
    text-align: center;
  }
  .rules-col .rules-button-group .el-button {
    display: inline-block;
    margin: 10px 30px !important;
    border-radius: 4px !important;
  }
</style>
